import { routerSelectors } from 'src/app/core/router/router.selectors'

import { Dictionary } from '@ngrx/entity'
import { createFeatureSelector, createSelector } from '@ngrx/store'

import { Message } from './message'
import * as fromMessage from './message.reducer'

const state = createFeatureSelector<fromMessage.MessageState>(
  fromMessage.FEATURE_NAME
)

const adapter = fromMessage.adapter.getSelectors()

const selectIds = createSelector(state, adapter.selectIds)
const selectAll = createSelector(state, adapter.selectAll)
const selectEntities = createSelector(state, adapter.selectEntities)
const selectIsLoading = createSelector(state, (state) => state.isLoading)

const selectState = createSelector(state, (state) => state && state)

const selectById = createSelector(
  selectEntities,
  (entities: Dictionary<Message>, id: number) => {
    return entities[id]
  }
)

const selectByFilter = createSelector(
  selectAll,
  (entities: Message[], filter?: { field: string; value: string | number }) => {
    if (filter) {
      return entities.filter((entity) => entity[filter.field] == filter.value)
    }

    return entities
  }
)

const selectIdRouteParam = createSelector(
  routerSelectors.selectRouteParams,
  (params) => {
    return params && params.messageId
  }
)

const selectCount = createSelector(
  selectAll,
  (entities) => entities && entities.length
)

export const messageSelectors = {
  selectState,
  selectIsLoading,
  selectById,
  selectIds,
  selectEntities,
  selectAll,
  selectByFilter,
  selectIdRouteParam,
  selectCount
}
